import { render, staticRenderFns } from "./gaincode.vue?vue&type=template&id=6392404a&scoped=true&"
import script from "./gaincode.vue?vue&type=script&lang=js&"
export * from "./gaincode.vue?vue&type=script&lang=js&"
import style0 from "./gaincode.vue?vue&type=style&index=0&id=6392404a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6392404a",
  null
  
)

export default component.exports